/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AdminUserSegmentDto { 
    /**
     * Segment key: hot, warm, cool, frozen, groupOnly or untouched
     */
    key: string;
    /**
     * People in this segment
     */
    users: number;
    /**
     * Share of the whole base, as a percentage
     */
    share: number;
}

